import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Client from 'types/Client';
import SourceClientType from 'sources/sourceTypes/Client';
import * as mapper from 'sources/mapper/Client';
import { PaginationParams } from 'sources/sourceTypes/Pagination';

export interface ClientParams extends PaginationParams {
  sessionIds?: [string];
}

class ClientSource extends BaseSource<Client, SourceClientType, ClientParams> {
  public ObjectURL = 'clients' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const clientSource = new ClientSource();

export default clientSource;
